export default {
  tableTent: "販促ツール",
  addPayment: "支払ブランドを追加",
  downloadTableTent: "データをダウンロード",
  ttips: {
    addPayment:
      "決済ブランドの追加申請は、WEB申込システムにログインのうえ行ってください。※ログインアカウントが不明な場合は、StarPayヘルプデスク（03-6555-7777）までご連絡ください。"
  }
};
